// extracted by mini-css-extract-plugin
export var containertwo = "layout-module--containertwo--1eA6U";
export var content = "layout-module--content--bviAP";